
// import React, { useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom"; // ✅ Added Link
// import "./LatestJobs.css";
// // import { FiExternalLink } from "react-icons/fi";

// const LatestJobs = () => {
//   const [jobs, setJobs] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((data) => {
//         console.log("Fetched Jobs:", data);
//         setJobs(data.reverse());
//       })
//       .catch((err) => {
//         console.error("Error fetching jobs:", err);
//       });
//   }, []);

//   return (
//     <div className="table-card">
//   <h3 className="table-title">Latest Jobs</h3>
//   <table className="styled-table">
//     <thead>
//       <tr>
//         <th>Job</th>
//       </tr>
//     </thead>
//     <tbody>
//       {jobs.slice(0, 15).map((job, index) => (
//         <tr key={index}>
//           <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
//             <Link to={`/job/${job.slug}`} className="job-link" style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                   }}>
            
//               {job.JobTitle}
//             </Link>
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>

//   {jobs.length > 15 && (
//     <div style={{ textAlign: "right", marginTop: "1rem" }}>
//       <button className="see-all-btn" onClick={() => navigate("/all-jobs")}>
//         See All Jobs
//       </button>
//     </div>
//   )}
// </div>

//   );
// };

// export default LatestJobs;




import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LatestJobs.css";

const LatestJobs = () => {
  // State to store jobs list
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;

    // ✅ Fetch only JobTitle & slug from the lightweight API
    fetch(`${API_URL}/jobs/titles`)
      .then((res) => res.json())
      .then((data) => {
        // console.log("Fetched Job Titles:", data);
        // Reverse to show latest first
        setJobs(data.reverse());
      })
      .catch((err) => {
        console.error("Error fetching jobs:", err);
      });
  }, []);

  return (
    <div className="table-card">
      <h3 className="table-title">Latest Jobs</h3>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Job</th>
          </tr>
        </thead>
        <tbody>
          {/* Show first 15 jobs */}
          {jobs.slice(0, 15).map((job, index) => (
            <tr key={index}>
              <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                {/* Bullet symbol */}
                <span
                  style={{
                    color: "#000",
                    fontSize: "20px",
                    lineHeight: "1",
                  }}
                >
                  •
                </span>
                {/* Link to job details page */}
                <Link
                  to={`/job/${job.slug}`}
                  className="job-link"
                  style={{
                    textDecoration: "none",
                    color: "#007bff",
                  }}
                >
                  {job.JobTitle}
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* See all jobs button */}
      {jobs.length > 15 && (
        <div style={{ textAlign: "right", marginTop: "1rem" }}>
          <button
            className="see-all-btn"
            onClick={() => navigate("/all-jobs")}
          >
            See All Jobs
          </button>
        </div>
      )}
    </div>
  );
};

export default LatestJobs;
